"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Util_1 = require("./Util");
var Container_1 = require("./Container");
var BaseLayer_1 = require("./BaseLayer");
var Global_1 = require("./Global");
var FastLayer = function (_super) {
  __extends(FastLayer, _super);
  function FastLayer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FastLayer.prototype._validateAdd = function (child) {
    var type = child.getType();
    if (type !== 'Shape') {
      Util_1.Util.throw('You may only add shapes to a fast layer.');
    }
  };
  FastLayer.prototype._setCanvasSize = function (width, height) {
    this.canvas.setSize(width, height);
    this._checkSmooth();
  };
  FastLayer.prototype.hitGraphEnabled = function () {
    return false;
  };
  FastLayer.prototype.drawScene = function (can) {
    var layer = this.getLayer(),
      canvas = can || layer && layer.getCanvas();
    if (this.clearBeforeDraw()) {
      canvas.getContext().clear();
    }
    Container_1.Container.prototype.drawScene.call(this, canvas);
    return this;
  };
  FastLayer.prototype.draw = function () {
    this.drawScene();
    return this;
  };
  return FastLayer;
}(BaseLayer_1.BaseLayer);
exports.FastLayer = FastLayer;
FastLayer.prototype.nodeType = 'FastLayer';
Global_1._registerNode(FastLayer);
Util_1.Collection.mapMethods(FastLayer);